import React from 'react';
import { SpectatorGameCard } from './SpectatorGameCard';
import type { ActiveGame } from './SpectatorGameCard';
import './SpectatorList.css';

interface SpectatorListProps {
  games: ActiveGame[];
  onGameClick: (gameId: string) => void;
  loading?: boolean;
}

export const SpectatorList: React.FC<SpectatorListProps> = ({ games, onGameClick, loading = false }) => {
  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '400px' 
      }}>
        <div style={{ fontSize: '18px', color: '#666' }}>Loading active games...</div>
      </div>
    );
  }

  if (games.length === 0) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '400px',
        flexDirection: 'column',
        gap: '16px'
      }}>
        <div style={{ fontSize: '18px', color: '#666' }}>No active games</div>
        <div style={{ fontSize: '14px', color: '#999' }}>Check back later to watch live games!</div>
      </div>
    );
  }

  return (
    <div className="spectator-list">
      {games.map((game) => (
        <SpectatorGameCard 
          key={game.gameId} 
          game={game} 
          onClick={() => onGameClick(game.gameId)}
        />
      ))}
    </div>
  );
};
